<template>
  <el-dialog title="闯关学员" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form class="form-custom" ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="110px">
      <el-form-item label="用户身份：">
        <el-select v-model="levelType" placeholder="请选择用户身份" @change="changeLevel">
          <!-- 1业务老师2技术老师3内部员工4加盟商5普通用户 -->
          <el-option label="业务老师" :value="1"></el-option>
          <el-option label="技术老师" :value="2"></el-option>
          <el-option label="内部员工" :value="3"></el-option>
          <el-option label="加盟商" :value="4"></el-option>
          <el-option label="普通用户" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="添加学员：">
        <!-- <el-select v-model="value" filterable clearable placeholder="可输入手机号/姓名进行搜索">
          <el-option v-for="item in options" :key="item.userId" :label="item.realName + '('+ item.levelName+')'" :value="item.userId"></el-option>
        </el-select>

        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button> -->
        <el-select v-model="value" filterable remote placeholder="请输入手机号/姓名进行搜索" :remote-method="searchUsers" :loading="loading">
          <el-option v-for="item in options" :key="item.userId" :label="item.realName + '('+ item.levelName+')'" :value="item.userId">
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleAdd" icon="el-icon-plus">添加学员</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list">
      <el-table-column label="姓名" prop="realName" align="center" />
      <el-table-column label="身份" prop="userIdentity" align="center" />
      <el-table-column label="手机号" prop="userPho" align="center" />
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click="handleDelete(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>

import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'
export default {
  data() {
    return {
      value: '',
      formVisible: false,
      formRules: {
        type: [{ required: true, message: '请选择用户身份', trigger: 'change' }],
        name: [{ required: true, message: '请输入关卡名称', trigger: 'blur' }],
        introduce: [{ required: true, message: '请输入关卡介绍', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      options: [],
      query: {
        pageNo: 1,
        pageSize: 100
      },
      rowItem: null,
      list: [],
      levelType: 4
    }
  },
  created() {
  },
  methods: {
    changeLevel() {
      this.value = ''
      this.options = []
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.barrierId = this.rowItem.id
      this.listLoading = true
      return courseSubjectBarrierStudentApi.fetchList(this.query)
        .then(data => {
          this.list = data.data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // handleSearch() {
    //   if (!this.value) return this.$message.warning('请输入手机号/姓名')
    //   this.getStudentList()
    // },
    // getStudentList() {
    //   courseSubjectBarrierStudentApi.fetchUsers({}).then(data => {
    //     this.options = data.data;
    //   })
    // },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          courseSubjectBarrierStudentApi.fetchUsers({ keyWords: query, type: this.levelType, pageNo: 1, pageSize: 100 }).then(data => {
            this.options = data.data.list;
          })
        }, 500);
      } else {
        this.options = [];
      }
    },
    // debouncedRemoteSearch(query) {

    // },
    // debounce(fn, wait) {
    //   // 自由变量，debounce执行完成被释放，time也不会被释放
    //   let time;
    //   // 返回一个闭包
    //   return function () {
    //     // 清除上一次的定时器
    //     if (time) {
    //       clearTimeout(time);
    //     };
    //     // wait时间后执行
    //     time = setTimeout(fn, wait);
    //   }
    // },
    handleStudent(row) {
      this.value = '';
      this.rowItem = row;
      this.options = [];
      this.doQueryList({})
      this.formVisible = true
    },
    handleAdd() {
      if (!this.value) return this.$message.error('请选择学员')
      let find = this.options.find(item => item.userId === this.value)
      let params = {
        barrierId: this.rowItem.id,
        tableId: find.tableId,
        tableName: find.type === 1 ? 'customer' : (find.type === 3 ? 'sys_user' : 'technician_info'),
        userId: find.userId,
      }
      courseSubjectBarrierStudentApi.create(params).then(res => {
        if (res.code === '0') {
          this.$message.success('操作成功')
          this.doQueryList({})
        }
      })
    },
    handleDelete(row) {
      this.$common.confirm('是否确认移除').then(() => courseSubjectBarrierStudentApi.deleteById(row.id))
        .then((res) => {
          this.$common.showMsg('success', '操作成功')
          this.doQueryList({})

        })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  display: flex;
}
::v-deep .el-select {
  width: 100%;
}
.el-button {
  margin-left: 5px;
}
</style>
